import React from 'react';
import Chip from '@material-ui/core/Chip';

const getStyle = (status) => {
  let label;
  let style;

  switch (status) {
    case 1:
      style = {
        backgroundColor: '#FFD700',
      };
      label = 'Em Aberto';
      return { label, style };
    case 2:
      style = {
        backgroundColor: '#00BFFF',
      };
      label = 'Andamento';
      return { label, style };
    case 3:
      style = {
        backgroundColor: '#32CD32',
      };
      label = 'Feito';
      return { label, style };
    case 4:
      style = {
        backgroundColor: '#FF0000',
      };
      label = 'Cancelado';
      return { label, style };
    default:
      style = {
        backgroundColor: '#696969',
      };
      label = '';
      return { label, style };
  }
};

function components(props) {
  const { status, handle } = props;
  const { label, style } = getStyle(status);
  return <Chip label={label} color="primary" style={style} onClick={handle} />;
}

export default components;
